import {LOGIN_ERROR, LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT, RENEW_SUCCESS} from '../actions'
import {getHostname} from "../utils/url";

const initialState = {
    authenticated: false,
    loading: false,
    account: undefined,
    error: undefined,
}

const account = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_REQUEST:
            return {
                ...state,
                loading: true
            };
        case LOGIN_SUCCESS:
            updateCookie(action.payload.account);
            return {
                ...state,
                authenticated: true,
                account: action.payload.account,
                error: undefined,
            };
        case LOGIN_ERROR:
            return {
                ...state,
                authenticated: false,
                account: undefined,
                error: action.payload.message,
            };
        case LOGOUT:
            return {
                ...state,
                loading: false,
                authenticated: false,
                account: undefined,
                error: undefined,
            };
        case RENEW_SUCCESS:{
            updateCookie(action.payload.account);
            return {
                ...state,
                account: action.payload.account,
            }
        }
        default:
            return state
    }
};

function setCookie(name, value, expires, path, theDomain, secure) {
    value = escape(value);
    document.cookie = name + "=" + value +
        ((expires) ? "; expires=" + expires.toGMTString() : "") +
        ((path) ? "; path=" + path : "") +
        ((theDomain) ? "; domain=" + theDomain : "") +
        ((secure) ? "; secure" : "");
}

const updateCookie = (authResult) => {

    var cookieToday = new Date();
    // Auth0 has a max of 24 hours for a token
    var expiryDate = new Date(cookieToday.getTime() + (24 * 60 * 60 * 1000));
    let hostname = getHostname();
    // clear old cookie on host with extra dot
    setCookie('token', authResult.accessToken, new Date(), '/', "." + hostname);
    // Set new cookie
    setCookie('token', authResult.accessToken, expiryDate, '/', hostname);
};

export default account



// WEBPACK FOOTER //
// ./src/reducers/account.js